import React from "react";
import { ConfirmContext } from "./ConfirmContext";

function useConfirm() {
  const confirm = React.useContext(ConfirmContext);

  return confirm;
}

export default useConfirm;
